import { collectionEngineV1 } from '../apis.js';
const wincentAPI = collectionEngineV1('/wincent');
export const getCasePrediction = async (caseId, context) => wincentAPI('POST', `/case-prediction/${caseId}`, {
    body: context,
});
export const updateCasePredictions = async () => wincentAPI('GET', `/update-case-predictions`);
//# sourceMappingURL=wincent.js.map